import { render } from "./ManageEventView.vue?vue&type=template&id=5faae106"
import script from "./ManageEventView.vue?vue&type=script&lang=js"
export * from "./ManageEventView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__